module.exports = __webpack_public_path__ + "static/media/smartphone-wally.1ff462d7.svg";